export default __webpack_public_path__ + "static/media/marin1.76886b84.jpg";